import { createContext, useContext } from "react";
import useDiscoveryPreference from "../hooks/useDiscoveryPreference";

const DiscoveryPreferenceContext = createContext(null);

export const DiscoveryPreferenceProvider = ({ children }) => {
    const preference = useDiscoveryPreference();

    return (
        <DiscoveryPreferenceContext.Provider value={preference}>
            {children}
        </DiscoveryPreferenceContext.Provider>
    );
};

export const useDiscoveryPreferenceContext = () => {
    const context = useContext(DiscoveryPreferenceContext);
    if (!context) {
        throw new Error("useDiscoveryPreferenceContext must be used within DiscoveryPreferenceProvider");
    }
    return context;
};
